import { deepCompare } from "@website/utils/deep-compare";
import loveEyesEmoji from "@website/widget/reserve-comment/reserve-comment-avavtar/assets/love-eyes-emoji.svg";
import pokerFaceEmoji from "@website/widget/reserve-comment/reserve-comment-avavtar/assets/poker-face-emoji.svg";
import sadEmoji from "@website/widget/reserve-comment/reserve-comment-avavtar/assets/sad-emoji.svg";
import { ReserveCommentAvatarPropertiesType } from "@website/widget/reserve-comment/reserve-comment-avavtar/reserve-comment-avatar.types";
import { memo } from "react";

const Component = ({ rate, className }: ReserveCommentAvatarPropertiesType) => (
  <img
    alt={
      rate < 2
        ? "sad-emoji"
        : rate >= 2 && rate < 4
          ? "poker-emoji"
          : "love-eyes-emoji"
    }
    className={className}
    height={32}
    loading="lazy"
    src={
      rate < 2
        ? sadEmoji?.src
        : rate >= 2 && rate < 4
          ? pokerFaceEmoji?.src
          : loveEyesEmoji?.src
    }
    width={32}
  />
);

export const ReserveCommentAvatar = memo(Component, deepCompare);
